import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import fetchSalonTagsList from 'actions/tags/fetchSalonTagsList.action';
import saveLocalTags from 'actions/tags/saveLocalTags.action';
import { selectBookingClientTags, selectClientTagsFromSalon } from 'selectors/simple';

import { createNewClient, pickClient } from 'booking/actions';
import AddNewClient from 'clientProfile/components/AddNewClient.component';

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ createNewClient, pickClient, saveLocalTags, fetchSalonTagsList }, dispatch);

const mapStateToProps = (state) => ({
  clientTags: selectBookingClientTags(state),
  newBooking: state.booking.data,
  newClient: state.booking.newClient,
  salonId: state.currentSalon.id,
  salonTags: selectClientTagsFromSalon(state),

});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddNewClient);
